export default __webpack_public_path__ + "static/media/buyNewCarImage.9c325c57.svg";